module.exports = __webpack_public_path__ + "static/img/part3-dis.386dd6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part3-dis.png
// module id = U3DM
// module chunks = 1